export const ATTENDANCE_SETTING_SUBMIT_RULES = {
  timeIntervalCheckInAndCheckOut: {
    required: true,
  },
};
export const ATTENDANCE_SETTING_PATH = "/human-resource/attendance/attendance-setting";

export const READ_ATTENDANCE_SETTING_CODE = 134011;
export const UPDATE_ATTENDANCE_SETTING_CODE = 134012;